import {db } from './setup';

export function watcherCotizaciones(callback) {
    const unsub = db
        .collection('cotizaciones')
        //.orderBy('fecha', desc)
        .onSnapshot((snapshot) => {
            const docs = [];
            snapshot.forEach((doc) => {
                const data = doc.data();
                docs.push({
                    ...data,
                    id: doc.id,
                });
            });
            callback(docs);
        });
    return unsub;
}

export function watcherVehiculos(callback) {
    const unsub = db
        .collection('vehiculos')
        .orderBy('marca')
        .onSnapshot((snapshot) => {
            const docs = [];

            snapshot.forEach((doc) => {
                const data = doc.data();

                docs.push({
                    ...data,
                    busq: data.marca + ' ' + data.modelo,
                    id: doc.id,
                });
            });
            callback(docs);
        });
    return unsub;
}



// WEBPACK FOOTER //
// ./src/services/firebase/watcher.js